export default {
  labels: {
    reply: 'Omistajan vastaus',
  },
  form: {
    reply_text: {
      placeholder: 'Kirjoita vastauksesi...',
    },
  },
  buttons: {
    generate_reply: 'Luo vastaus',
    submit_reply: 'Lähetä vastaus',
  },
  toasts: {
    failed_to_create_reply: 'Vastauksen luominen epäonnistui',
    failed_to_generate_ai_reply: 'Tekoälyvastauksen luominen epäonnistui',
  },
};
